export default __webpack_public_path__ + "static/media/SpanelskaSynagoga_sm.9a2fab29.jpg";